import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { ElectionHeaderStyles } from "./styles/ElectionHeaderStyles";
var ElectionHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle;
    var t = useTranslation().t;
    return (_jsxs(ElectionHeaderStyles.Wrapper, { children: [_jsx(ElectionHeaderStyles.Title, { children: t(title) }), _jsx(ElectionHeaderStyles.SubTitle, { children: t(subtitle) })] }));
};
export default ElectionHeader;
